import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '../../../../../../../../../core/animations';

// Util files
import { displayValues } from '../../../../../../utils';
@Component({
  selector: 'spekwo-manage-references',
  templateUrl: './manage-references.component.html',
  styleUrls: ['./manage-references.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class ManageReferencesComponent implements OnInit {

  displayValues = displayValues;
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/operations/manage-references/manage-references.component.ts